const lpd_tip_content = '为减少人员聚集，缩短交易时间，房产交易部门将按照公正摇号排序选房顺序号，先对提供给棚改货币化安置住户、刚需家庭、普通家庭房源数的150%进行购房资格复核，若复核后具备购房资格的棚改货币化安置住户、刚需家庭，普通家庭数量不足相应房源的120%，房产交易部门将依公正摇号选房排序序号，依序开展后续登记购房人的资格复核工作，直至具备购房资格的家庭数量达到对应房源的120%。'
export default {
    data () {
        return {
            lpd_tip_title: '为什么会出现暂未复核？',
            lpd_tip_content,
            show_lpd_tip: false
        }
    },
    methods: {
        toggleLpdTip () {
            this.show_lpd_tip = !this.show_lpd_tip
        }
    }
}